export enum DOMESTIC_COLOURS {
  NORMAL = "#4CAF50",
  WARNING = "#FF5722",
  ALERT = "#F44336",
}